import React, { useState, useEffect, useContext } from 'react';
import {
  getMedias,
  register,
  getProfilesData,
  updateUser,
  deleteUser,
  updateUserProfile,
} from '../../../api/Api';
import BreadCrumb from '../../../components/admin/Breadcrumb';
import Header from '../../../components/Header';
import { useToasts } from 'react-toast-notifications';
import DeleteUserOverlay from '../../../components/overlays/DeleteUserOverlay';
import Select from 'react-select';
import { useLoadingContext } from '../../../contexts/LoadingContext';
import { ProfileContext } from '../../../contexts/ProfileContext';
import Switch from 'react-switch';
import Unauthorized from '../../../components/Unauthorized';

const CreateUserPage = () => {
  const [selectedMedia, setSelectedMedia] = useState({ name: '', id: null });
  const [userId, setUserId] = useState(0);
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [address, setAddress] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otherEmails, setOtherEmails] = useState('');
  const [users, setUsers] = useState([]);
  const { addToast } = useToasts();
  const [displayModal, setDisplayModal] = useState(false);
  const [userToDelete, setUserToDelete] = useState({});
  const [displayDeleteUser, setDisplayDeleteUser] = useState(false);
  const [mediasOptions, setMediasOptions] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [createMode, setCreateMode] = useState(false);
  const { profile, fetchProfileData, isLoadingProfile } = useContext(ProfileContext);
  const { loading, setLoading } = useLoadingContext();

  // Estilos personalizados para react-select
  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? '#3273dc' : '#dbdbdb',
      boxShadow: state.isFocused ? '0 0 0 3px rgba(50, 115, 220, 0.25)' : 'none',
      '&:hover': {
        borderColor: '#3273dc',
      },
      borderRadius: '6px',
      padding: '0.2rem 0.5rem',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#3273dc' : state.isFocused ? '#f0f8ff' : 'white',
      color: state.isSelected ? 'white' : '#333',
    }),
  };

  const getMediasData = async () => {
    setLoading(true);
    try {
      const { json: mediasJson } = await getMedias('usersCreation=true');
      const profilesJson = await getProfilesData();
      setUsers(profilesJson);
      setMediasOptions(
        mediasJson.map((media) => {
          return {
            value: media.name,
            label: media.name,
            id: media.id_medio,
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    getMediasData();
  }, []);

  const newUser = async () => {
    setEditMode(false);
    setCreateMode(true);
    setDisplayModal(true);
  };

  const registerUser = async () => {
    setLoading(true);
    if (username.includes(' ')) {
      addToast('El nombre de usuario no puede contener espacios', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 5000,
        placement: 'bottom-center',
      });
      return setLoading(false);
    }
    const user = {
      username,
      email,
      password,
      address,
      phone_number: phoneNumber,
      id_medio: selectedMedia.id,
      other_mails: otherEmails,
    };
    try {
      const response = await register(user);
      if (response.ok) {
        addToast('Usuario creado con exito', {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000,
          placement: 'bottom-center',
        });
        setUsername('');
        setPassword('');
        setEmail('');
        setAddress('');
        setPhoneNumber('');
        setSelectedMedia({ name: '', id: null });
        setOtherEmails('');
        setDisplayModal(false);
      } else {
        const text = await response.text();
        let errorMessage;
        try {
          const jsonError = JSON.parse(text);
          if (typeof jsonError === 'object') {
            errorMessage = Object.values(jsonError).flat().join('\n');
          }
        } catch {
          errorMessage = text.includes('already exists')
            ? 'Ya existe un Usuario con ese nombre de usuario o correo'
            : text;
        }
        addToast(errorMessage, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 5000,
          placement: 'bottom-center',
        });
      }
      await getMediasData();
    } catch (error) {
      addToast(error.message, {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 5000,
        placement: 'bottom-center',
      });
    }
    setLoading(false);
  };

  const editUser = async () => {
    setLoading(true);
    if (username.includes(' ')) {
      addToast('El nombre de usuario no puede contener espacios', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 5000,
        placement: 'bottom-center',
      });
      return setLoading(false);
    }
    const user = {
      username,
      email,
      password,
      address,
      phone_number: phoneNumber,
      other_mails: otherEmails,
    };
    try {
      const response = await updateUser(userId, user);
      if (response.ok) {
        addToast('Usuario modificado con exito', {
          appearance: 'success',
          autoDismiss: true,
          autoDismissTimeout: 3000,
          placement: 'bottom-center',
        });
        setUserId(0);
        setUsername('');
        setPassword('');
        setEmail('');
        setAddress('');
        setPhoneNumber('');
        setSelectedMedia({ name: '', id: null });
        setOtherEmails('');
        setDisplayModal(false);
      } else {
        const text = await response.text();
        let errorMessage;
        try {
          const jsonError = JSON.parse(text);
          if (typeof jsonError === 'object') {
            errorMessage = Object.values(jsonError).flat().join('\n');
          }
        } catch {
          errorMessage = text.includes('already exists')
            ? 'Ya existe un Usuario con ese nombre de usuario o correo'
            : text;
        }
        addToast(errorMessage, {
          appearance: 'error',
          autoDismiss: true,
          autoDismissTimeout: 5000,
          placement: 'bottom-center',
        });
      }
      await getMediasData();
    } catch (error) {
      addToast(error.message, {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 5000,
        placement: 'bottom-center',
      });
      console.log(error);
    }
    setLoading(false);
  };

  const onConfirmDelete = async () => {
    setLoading(true);
    try {
      await deleteUser(userToDelete.user.id);
      setDisplayDeleteUser(false);
      addToast('Usuario borrado con exito', {
        appearance: 'success',
        autoDismiss: true,
        autoDismissTimeout: 3000,
        placement: 'bottom-center',
      });
    } catch (error) {
      setDisplayDeleteUser(false);
      addToast('Algo salio mal, no se pudo borrar el usuario', {
        appearance: 'error',
        autoDismiss: true,
        autoDismissTimeout: 5000,
        placement: 'bottom-center',
      });
    }
    await getMediasData();
    setLoading(false);
  };

  const cancelUserCreation = () => {
    setDisplayModal(false);
    setSelectedMedia({ name: '', id: null });
    setUsername('');
    setEmail('');
    setPassword('');
    setAddress('');
    setPhoneNumber('');
    setOtherEmails('');
  };

  const handleSelectMedia = (value) => {
    setSelectedMedia({ name: value.value, id: value.id });
  };

  const handleSetFinanceData = async (user) => {
    const { can_see_finance_data: canSeeFinanceData, id } = user;
    await updateUserProfile(id, { can_see_finance_data: !canSeeFinanceData });
    await getMediasData();
  };

  const manageOtherMails = (value) => {
    const emailParts = value.split(/;\s*/);
    const validEmails = [];
    let currentInput = '';

    emailParts.forEach((part, index) => {
      if (part.includes('@')) {
        validEmails.push(part);
      } else {
        currentInput = part;
      }
    });

    let result = validEmails.join(';');

    if (currentInput.trim() !== '') {
      result += (result ? ';' : '') + currentInput;
    }

    if (value.endsWith(' ')) {
      result += ';';
    }

    setOtherEmails(result);
  };

  const UsersTable = () => {
    return (
      <div className="box" style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', padding: '2rem' }}>
        
        <div className="table-container" style={{ borderRadius: '8px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)' }}>
          <table className="table is-fullwidth is-striped is-hoverable">
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th className="has-text-weight-bold has-text-left" style={{ minWidth: '180px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-user"></i>
                    </span>
                    <span>Usuario</span>
                  </span>
                </th>
                <th className="has-text-weight-bold has-text-left" style={{ minWidth: '250px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-tv"></i>
                    </span>
                    <span>Medio</span>
                  </span>
                </th>
                <th className="has-text-weight-bold has-text-left" style={{ minWidth: '250px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-envelope"></i>
                    </span>
                    <span>Email</span>
                  </span>
                </th>
                <th className="has-text-weight-bold has-text-center" style={{ minWidth: '120px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-dollar"></i>
                    </span>
                    <span>Ve Finanzas</span>
                  </span>
                </th>
                <th className="has-text-weight-bold has-text-center" style={{ minWidth: '100px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-edit"></i>
                    </span>
                    <span>Editar</span>
                  </span>
                </th>
                <th className="has-text-weight-bold has-text-center" style={{ minWidth: '100px' }}>
                  <span className="icon-text">
                    <span className="icon is-small mr-2">
                      <i className="fa fa-trash"></i>
                    </span>
                    <span>Borrar</span>
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {users.map((user) => {
                return (
                  <tr 
                    key={user.id}
                    className="hover-row"
                    style={{
                      transition: 'all 0.2s ease',
                      borderLeft: `4px solid ${user.is_admin ? '#f39c12' : '#48c78e'}`,
                    }}
                  >
                    <td className="is-vcentered has-text-left">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={`tag ${user.is_admin ? 'is-warning' : 'is-success'} is-light has-text-weight-medium mr-2`}>
                          {user.is_admin ? 'Admin' : 'User'}
                        </span>
                        <span className="has-text-weight-medium">{user.user?.username}</span>
                      </div>
                    </td>
                    <td className="is-vcentered has-text-left">
                      <span className="has-text-weight-medium has-text-dark">
                        {user.media?.name || 'Sin medio asignado'}
                      </span>
                    </td>
                    <td className="is-vcentered has-text-left">
                      <span className="has-text-weight-medium has-text-grey-dark">
                        {user.user?.email}
                      </span>
                    </td>
                    <td className="is-vcentered has-text-centered">
                      <Switch
                        checked={user.can_see_finance_data}
                        onChange={() => handleSetFinanceData(user)}
                        onColor="#48c78e"
                        offColor="#f14668"
                        checkedIcon={false}
                        uncheckedIcon={false}
                        height={20}
                        width={40}
                      />
                    </td>
                    <td className="is-vcentered has-text-centered">
                      <button
                        className="button is-info is-small is-rounded"
                        disabled={user.is_admin}
                        onClick={(e) => {
                          e.preventDefault();
                          setUserId(user.user.id);
                          setUsername(user.user.username);
                          setPassword('');
                          setEmail(user.user.email);
                          setAddress(user.address);
                          setPhoneNumber(user.phone_number);
                          setOtherEmails(user.other_mails);
                          setDisplayModal(true);
                          setCreateMode(false);
                          setEditMode(true);
                        }}
                        style={{
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                        title={user.is_admin ? 'No se puede editar admin' : 'Editar usuario'}
                      >
                        <span className="icon is-small">
                          <i className="fas fa-user-edit"></i>
                        </span>
                        <span>Editar</span>
                      </button>
                    </td>
                    <td className="is-vcentered has-text-centered">
                      <button
                        className="button is-danger is-small is-rounded"
                        disabled={user.is_admin}
                        onClick={(e) => {
                          e.preventDefault();
                          setUserToDelete(user);
                          setDisplayDeleteUser(true);
                        }}
                        style={{
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        }}
                        title={user.is_admin ? 'No se puede borrar admin' : 'Borrar usuario'}
                      >
                        <span className="icon is-small">
                          <i className="fas fa-trash-alt"></i>
                        </span>
                        <span>Borrar</span>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th className="has-text-weight-bold has-text-left">Usuario</th>
                <th className="has-text-weight-bold has-text-left">Medio</th>
                <th className="has-text-weight-bold has-text-left">Email</th>
                <th className="has-text-weight-bold has-text-centered">Ve Finanzas</th>
                <th className="has-text-weight-bold has-text-centered">Editar</th>
                <th className="has-text-weight-bold has-text-centered">Borrar</th>
              </tr>
            </tfoot>
          </table>
        </div>
        
        {users.length === 0 && (
          <div className="has-text-centered" style={{ padding: '3rem' }}>
            <span className="icon is-large has-text-grey-light">
              <i className="fa fa-users fa-3x"></i>
            </span>
            <p className="title is-4 has-text-grey-light mt-4">No hay usuarios registrados</p>
            <p className="subtitle has-text-grey">Comienza creando el primer usuario</p>
          </div>
        )}
      </div>
    );
  };

  if (isLoadingProfile) {
    return (
      <div className="section">
        <div className="container has-text-centered">
          <div className="box" style={{ borderRadius: '12px', padding: '3rem' }}>
            <span className="icon is-large has-text-primary">
              <i className="fa fa-spinner fa-pulse fa-3x"></i>
            </span>
            <p className="title is-4 mt-4">Cargando...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Header />
      {profile.is_admin ? (
        <div>
          <BreadCrumb activeSection={'Usuarios'} />
          
          {/* ✅ SECCIÓN PRINCIPAL MODERNIZADA */}
          <section className="section">
            <div className="container">
              <div className="columns is-centered mb-5">
                <div className="column is-8">
                  <div 
                    className="box has-text-centered"
                    style={{
                      borderRadius: '12px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      color: 'white',
                      padding: '2rem',
                      margin: '0',
                    }}
                  >
                    <h1 className="title is-3 has-text-white has-text-weight-bold mb-4">
                      <span className="icon-text">
                        <span className="icon is-large mr-3">
                          <i className="fa fa-users-cog fa-2x"></i>
                        </span>
                        <span className="ml-3">Gestión de Usuarios</span>
                      </span>
                    </h1>
                    <p className="subtitle is-5 has-text-white-ter mb-5">
                      Administra los usuarios del sistema, crea nuevos perfiles y gestiona permisos
                    </p>
                    <button 
                      className="button is-light is-normal is-rounded"
                      onClick={() => newUser()}
                      style={{
                        transition: 'all 0.3s ease',
                        boxShadow: '0 4px 8px rgba(255, 255, 255, 0.3)',
                        fontWeight: '600',
                      }}
                    >
                      <span className="icon">
                        <i className="fa fa-user-plus"></i>
                      </span>
                      <span>Añadir Nuevo Usuario</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* ✅ TABLA DE USUARIOS MODERNIZADA */}
              <UsersTable />
              
              {/* ✅ BOTÓN FLOTANTE ADICIONAL */}
              <div className="has-text-centered mt-5">
                <button 
                  className="button is-primary is-medium is-rounded"
                  onClick={() => newUser()}
                  style={{
                    transition: 'all 0.2s ease',
                    boxShadow: '0 4px 8px rgba(50, 115, 220, 0.3)',
                  }}
                >
                  <span className="icon">
                    <i className="fa fa-plus"></i>
                  </span>
                  <span>Añadir Otro Usuario</span>
                </button>
              </div>
            </div>
          </section>

          {/* ✅ MODAL MODERNIZADO */}
          <div className={`modal ${displayModal ? 'is-active' : ''}`}>
            <div className="modal-background" onClick={cancelUserCreation}></div>
            <div className="modal-card" style={{ borderRadius: '12px', overflow: 'hidden', maxWidth: '600px' }}>
              <header 
                className="modal-card-head" 
                style={{ 
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
                  color: 'white' 
                }}
              >
                <p className="modal-card-title has-text-weight-bold has-text-white">
                  <span className="icon-text">
                    <span className="icon mr-2">
                      <i className={`fa ${editMode ? 'fa-user-edit' : 'fa-user-plus'}`}></i>
                    </span>
                    <span>{editMode ? 'Editar Usuario' : 'Crear Nuevo Usuario'}</span>
                  </span>
                </p>
                <button 
                  className="delete" 
                  aria-label="close" 
                  onClick={cancelUserCreation}
                  style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}
                ></button>
              </header>
              
              <section className="modal-card-body" style={{ padding: '2rem' }}>
                <div className="columns is-multiline">
                  <div className="column is-6">
                    <div className="field">
                      <label htmlFor="username" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-user"></i>
                          </span>
                          <span>Nombre de usuario</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          autoComplete="none"
                          key={'usernameInput'}
                          id="username"
                          type="text"
                          className="input"
                          onChange={(e) => setUsername(e.target.value)}
                          value={username}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-user"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label htmlFor="mail" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-envelope"></i>
                          </span>
                          <span>Correo</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          autoComplete="none"
                          type="email"
                          className="input"
                          onChange={(event) => setEmail(event.target.value)}
                          value={email}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-envelope"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label htmlFor="address" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-home"></i>
                          </span>
                          <span>Domicilio</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          autoComplete="none"
                          id="address"
                          type="text"
                          className="input"
                          onChange={(event) => setAddress(event.target.value)}
                          value={address}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-home"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="column is-6">
                    <div className="field">
                      <label htmlFor="phoneNumber" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-phone"></i>
                          </span>
                          <span>Teléfono</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          autoComplete="none"
                          id="phoneNumber"
                          type="text"
                          className="input"
                          onChange={(event) => setPhoneNumber(event.target.value)}
                          value={phoneNumber}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-phone"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="column is-12">
                    <div className="field">
                      <label htmlFor="otherEmails" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-envelope-o"></i>
                          </span>
                          <span>Otros Emails</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          autoComplete="none"
                          id="otherEmails"
                          type="text"
                          className="input"
                          onChange={(event) => manageOtherMails(event.target.value)}
                          value={otherEmails}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-envelope-o"></i>
                        </span>
                      </div>
                      <p className="help has-text-info">
                        <span className="icon is-small">
                          <i className="fa fa-info-circle"></i>
                        </span>
                        Apretando barra de espacio al completar un email, se agregará un ; (punto y coma) separador
                      </p>
                    </div>
                  </div>

                  {createMode && (
                    <div className="column is-12">
                      <div className="field">
                        <label htmlFor="dropdown" className="label has-text-weight-semibold">
                          <span className="icon-text">
                            <span className="icon is-small mr-2">
                              <i className="fa fa-tv"></i>
                            </span>
                            <span>Medio / Repetidora</span>
                          </span>
                        </label>
                        <Select
                          options={mediasOptions}
                          onChange={(value) => handleSelectMedia(value)}
                          placeholder={'Seleccionar Medio'}
                          styles={customSelectStyles}
                        />
                      </div>
                    </div>
                  )}

                  <div className="column is-12">
                    <div className="field">
                      <label htmlFor="mail" className="label has-text-weight-semibold">
                        <span className="icon-text">
                          <span className="icon is-small mr-2">
                            <i className="fa fa-lock"></i>
                          </span>
                          <span>Contraseña</span>
                        </span>
                      </label>
                      <div className="control has-icons-left">
                        <input
                          type="password"
                          autoComplete="none"
                          className="input"
                          onChange={(event) => setPassword(event.target.value)}
                          value={password}
                          style={{ borderRadius: '6px' }}
                        />
                        <span className="icon is-small is-left">
                          <i className="fa fa-lock"></i>
                        </span>
                      </div>
                      <p className="help has-text-info">
                        <span className="icon is-small">
                          <i className="fa fa-exclamation-triangle"></i>
                        </span>
                        El usuario debe cambiar la contraseña en su primer login
                      </p>
                    </div>
                  </div>
                </div>
              </section>
              
              <footer className="modal-card-foot" style={{ backgroundColor: '#f8f9fa', padding: '1.5rem 2rem' }}>
                <div className="field is-grouped is-grouped-right">
                  <div className="control">
                    <button
                      className="button is-light is-medium"
                      onClick={cancelUserCreation}
                      disabled={loading}
                      style={{
                        borderRadius: '8px',
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <span className="icon">
                        <i className="fa fa-times"></i>
                      </span>
                      <span>Cancelar</span>
                    </button>
                  </div>
                  <div className="control">
                    {editMode ? (
                      <button
                        disabled={
                          loading ||
                          username.length === 0 ||
                          email.length === 0 ||
                          !email.includes('@')
                        }
                        className="button is-success is-medium"
                        onClick={editUser}
                        style={{
                          borderRadius: '8px',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 8px rgba(72, 199, 142, 0.3)',
                        }}
                      >
                        <span className="icon">
                          <i className="fa fa-save"></i>
                        </span>
                        <span>Actualizar Usuario</span>
                      </button>
                    ) : (
                      <button
                        disabled={
                          loading ||
                          username.length === 0 ||
                          password.length < 6 ||
                          email.length === 0 ||
                          !email.includes('@') ||
                          !selectedMedia.id
                        }
                        className="button is-primary is-medium"
                        onClick={registerUser}
                        style={{
                          borderRadius: '8px',
                          transition: 'all 0.2s ease',
                          boxShadow: '0 2px 8px rgba(50, 115, 220, 0.3)',
                        }}
                      >
                        <span className="icon">
                          <i className="fa fa-user-plus"></i>
                        </span>
                        <span>Crear Usuario</span>
                      </button>
                    )}
                  </div>
                </div>
              </footer>
            </div>
          </div>

          {/* ✅ OVERLAY DE CONFIRMACIÓN DE BORRADO */}
          <DeleteUserOverlay
            isActive={displayDeleteUser}
            user={userToDelete.user}
            onPressCancel={() => setDisplayDeleteUser(false)}
            onPressConfirm={onConfirmDelete}
          />
        </div>
      ) : (
        <Unauthorized />
      )}

      {/* ✅ ESTILOS CSS ADICIONALES */}
      <style jsx>{`
        .hover-row:hover {
          background-color: rgba(0, 0, 0, 0.05) !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        }

        .button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
        }

        .table th {
          background-color: #f8f9fa;
          border-bottom: 2px solid #dee2e6;
          padding: 1rem 0.75rem;
          vertical-align: middle;
        }

        .table td {
          padding: 1rem 0.75rem;
          vertical-align: middle;
        }

        .table-container {
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }

        .tag {
          font-weight: 600;
          border-radius: 20px;
        }

        .box {
          border-radius: 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .field .label {
          color: #4a4a4a;
          font-size: 0.9rem;
          font-weight: 600;
          margin-bottom: 0.5rem;
        }

        .input {
          border-radius: 6px;
          transition: all 0.2s ease;
        }

        .input:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }

        .modal-card {
          max-width: 90vw;
          width: 600px;
        }

        .icon-text {
          align-items: center;
        }

        .help {
          font-size: 0.8rem;
          margin-top: 0.5rem;
        }

        /* Gradiente para el header principal */
        .button.is-light.is-large:hover {
          background-color: rgba(255, 255, 255, 0.9);
          transform: translateY(-2px);
          box-shadow: 0 6px 12px rgba(255, 255, 255, 0.4);
        }

        /* Mejoras para el switch */
        .react-switch {
          vertical-align: middle;
        }

        /* Estados disabled mejorados */
        .button:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .button:disabled:hover {
          transform: none;
          box-shadow: none;
        }

        /* Responsive */
        @media screen and (max-width: 768px) {
          .columns {
            margin: 0 !important;
          }

          .column {
            padding: 0.4rem !important;
          }

          .table-container {
            overflow-x: auto;
          }

          .modal-card {
            max-width: 95vw;
            width: auto;
            margin: 0 1rem;
          }

          .field.is-grouped.is-grouped-right {
            justify-content: center;
          }

          .field.is-grouped .control {
            margin-bottom: 0.5rem;
          }
        }

        /* Mejoras en la accesibilidad */
        .button:focus,
        .input:focus {
          box-shadow: 0 0 0 3px rgba(50, 115, 220, 0.25);
        }

        /* Animaciones suaves */
        .box,
        .button,
        .hover-row,
        .input {
          transition: all 0.3s ease;
        }

        /* Mejora visual para inputs con iconos */
        .has-icons-left .input {
          padding-left: 2.5rem;
        }

        .has-icons-left .icon {
          color: #b5b5b5;
          pointer-events: none;
        }

        .has-icons-left .input:focus ~ .icon {
          color: #3273dc;
        }
      `}</style>
    </div>
  );
};

export default CreateUserPage;